import { render, staticRenderFns } from "./SplitedTreeDialog.vue?vue&type=template&id=7124ac8c"
import script from "./SplitedTreeDialog.vue?vue&type=script&lang=js"
export * from "./SplitedTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./SplitedTreeDialog.vue?vue&type=style&index=0&id=7124ac8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports